// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { partNumbersStyle } from "@pace/App/ComponentExtensions/ProductPartNumbersExtensions";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsRequestedDetailsGridStyles } from "@pace/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { mergeWithCss } from "@pace/XDL/Utilities/mergeWithCss";
import xScreen from "@pace/XDL/Utilities/xScreen";
import { css } from "styled-components";

rfqQuoteDetailsRequestedDetailsGridStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
rfqQuoteDetailsRequestedDetailsGridStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPrice = {
    ...mergeWithCss(cartLineSharedStyles.productPrice, {
        price: {
            qtyPerBaseUnitOfMeasureText: {
                css: css`
                    display: none;
                `,
            },
        },
    }),
};

rfqQuoteDetailsRequestedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeLabelText = {
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 10px;
        margin-right: 10px;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
        }
    `,
};
rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle = {
    wrapper: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.wrapper, {
            css: css`
                grid-template-columns: 91px minmax(0, 267px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(
                        0,
                        135px
                    );
            `,
        }),
    },
    availability: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.availability, {
            css: css`
                grid-column: 4 / 5;
            `,
        }),
    },
    itemDescription: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.itemDescription, {
            css: css`
                grid-column: 1 / 4;
            `,
        }),
    },
    total: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.total, {
            css: css`
                border-right: none;
                grid-column: 7 / 8;
            `,
        }),
    },
    priceUnit: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.priceUnit, {
            css: css`
                grid-column: 5 / 6;
            `,
        }),
    },
    qty: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.linesHeaderStyle?.qty, {
            css: css`
                grid-column: 6 / 7;
            `,
        }),
    },
};
rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer = {
    container: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.container, {
            css: css`
                grid-template-columns: 91px minmax(0, 267px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(
                        0,
                        135px
                    );
            `,
        }),
    },
    availability: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.availability, {
            css: css`
                grid-column: 4/ 5;
            `,
        }),
    },
    description: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.description, {
            css: css`
                grid-column: 2/ 4;
            `,
        }),
    },
    qty: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.availability, {
            css: css`
                grid-column: 6 / 7;
            `,
        }),
    },
    price: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.availability, {
            css: css`
                grid-column: 5 / 6;
            `,
        }),
    },
    total: {
        ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer?.total, {
            css: css`
                grid-column: 7 / 8;
            `,
        }),
    },
};
rfqQuoteDetailsRequestedDetailsGridStyles.headerWrapper = {
    ...mergeWithCss(rfqQuoteDetailsRequestedDetailsGridStyles.headerWrapper, {
        css: css`
            ${xScreen("gt", "lg")} {
                border: none;
            }
        `,
    }),
};
rfqQuoteDetailsRequestedDetailsGridStyles.segmentLabel = {
    ...partNumbersStyle.label,
};
rfqQuoteDetailsRequestedDetailsGridStyles.segmentValue = {
    ...partNumbersStyle.value,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productAvailability = {
    container: {
        css: css`
            flex-direction: column;
        `,
    },
    messageGridItem: {
        width: 12,
    },
};
rfqQuoteDetailsRequestedDetailsGridStyles.nonStockInventoryMessage = {
    size: 12,
    weight: "bold",
    forwardAs: "p",
    lineHeight: "12px",
};
rfqQuoteDetailsRequestedDetailsGridStyles.nonStockNotes = {
    ...cartLineSharedStyles.productDescription?.productDetailDescription,
};
rfqQuoteDetailsRequestedDetailsGridStyles.nonStockPartNumberLabel = {
    ...partNumbersStyle.label,
};
rfqQuoteDetailsRequestedDetailsGridStyles.nonStockPartNumberValue = {
    ...partNumbersStyle.value,
};